/** Full page load, so no in-memory state from the previous session survives. */
export const hardNavigate = (url: string) => {
  window.location.href = url
}
